import React, { useEffect } from 'react'
import classNames from 'classnames'
import generalClasses from './Wizard.module.css'
import classes from './PlansStep.module.css'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
    isWizardStepComplete,
    nextWizardStep,
    jumpToWizardStep,
} from './wizardLogic'
import { selectPlan } from '../Cart/cartApi'
import { userSelectors } from '../../redux/userSlice'
import notification from '../../components/Notification/notification'
import { UserTypes } from '../../util/constants'
import { IndividualPlans } from '../../components/Plans/IndividualPlans'
import { BusinessPlans } from '../../components/Plans/BusinessPlans'

const PlansStep = () => {
    const dispatch = useDispatch()

    const userDetails = useSelector(userSelectors.userDetails)

    useEffect(() => {
        if (isWizardStepComplete('select-plan')) {
            jumpToWizardStep('checkout')
        }
    }, [])

    const handleSelectPlan = async plan => {
        const [dismiss] = await notification.loading({
            title: 'Selecting plan...',
        })
        const successful = await dispatch(
            selectPlan({ id: plan.subid, planInfo: plan })
        )
        dismiss()
        if (successful) {
            nextWizardStep()
        } else {
            notification.failure({
                title: 'An error occured',
                description: 'Failed to select plan, please try again.',
            })
        }
    }

    return (
        <div
            className={classNames(
                generalClasses.wizardContent,
                generalClasses.wizardContentFlush
            )}
        >
            <div className={generalClasses.wizardContentCentered}>
                {userDetails.userType === UserTypes.Personal && (
                    <IndividualPlans onSelect={handleSelectPlan} />
                )}
                {userDetails.userType === UserTypes.Business && (
                    <BusinessPlans onSelect={handleSelectPlan} />
                )}
            </div>
            <div
                className={classNames(
                    generalClasses.wizardContentCentered,
                    classes.learnMoreSection
                )}
            >
                <Link className={classes.learnMoreLink}>View more details</Link>
            </div>
        </div>
    )
}

export default PlansStep
